const ListItem = {
    baseStyle: {
        fontSize: '30px',
        color: 'primary',
    }
};

export default ListItem;